import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { LlaveService } from 'src/app/shared/services/llave.service';

/**
 * Deja entrar a `/client/referidos` sólo si el cliente ve referidos: programa
 * encendido y una campaña activa de su país (Chile o Venezuela, por su
 * documento). Complementa el ocultamiento del menú para el acceso por URL
 * directa: un venezolano no ve una campaña de Chile, ni al revés.
 *
 * No lee el store: el backend saca al usuario del token, así que funciona
 * igual en un refresh directo, cuando el navbar todavía no rehidrató nada.
 * Ante cualquier error `miPrograma()` responde `visible: false` y se manda al
 * home, que es el lado seguro.
 */
@Injectable({ providedIn: 'root' })
export class ReferidosGuard implements CanActivate {
  constructor(
    private llaveService: LlaveService,
    private router: Router,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const { visible } = await this.llaveService.miPrograma();
    return visible ? true : this.router.parseUrl('/wallet/home');
  }
}
